function idMapper(api: string, id: string) {
    return api.replace(":id", id)
}

export default idMapper
